var _path, _path2, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSmartfill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92147 3.10547H9.95506L10.4893 3.63881V6.38384L11.2373 6.98295L10.4893 7.6801V10.2073L9.95506 10.9262H8.92147",
    stroke: "black",
    strokeWidth: 0.93538
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23722 3.10547H5.20363L4.66935 3.63881V6.38384L3.92143 6.98295L4.66935 7.6801V10.2073L5.20363 10.9262H6.23722",
    stroke: "black",
    strokeWidth: 0.93538
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07935,
    y: 0.515625,
    width: 13,
    height: 13,
    stroke: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartfill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smartfill.1614ce3942208cc7164ed3a455484836.svg";